<script>
export default {
  name: "DidoMillesimeTabApi",
};
</script>

<script setup>
import DidoMillesimeBlockApiDoc from "../api/Doc.vue";
import DidoMillesimeBlockApiVars from "../api/Vars.vue";

const props = defineProps({
  apiUrl: { type: String, required: true },
  rid: { type: String, required: true },
  millesime: { type: String, required: true },
  columns: { type: Array, required: true },
});
</script>

<template>
  <div>
    <QExpansionItem
      group="api"
      label="Variables"
      header-class="text-small bg-grey-2"
    >
      <DidoMillesimeBlockApiVars
        :api-url="props.apiUrl"
        :columns="props.columns"
      />
    </QExpansionItem>
    <QExpansionItem
      default-opened
      group="api"
      label="Apidoc"
      header-class="text-small bg-grey-2"
    >
      <div>
        <DidoMillesimeBlockApiDoc
          :api-url="props.apiUrl"
          :rid="props.rid"
          :millesime="props.millesime"
        />
      </div>
    </QExpansionItem>
  </div>
</template>
